/**
 * Scoped CSS for the Organizations onboarding hero — only the bits inline
 * styles can't do (the hero gradient halo, reduced-motion). All colors come from
 * `--vn-*` tokens. Rendered once per screen; duplicate <style> tags with
 * identical content are harmless. Mirrors the OSS onboarding look.
 */
export function OnboardingCss() {
  return <style>{CSS}</style>;
}

const CSS = `
.vn-ob-hero {
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(120% 80% at 50% -10%,
      var(--vn-primary-subtle) 0%, transparent 60%),
    var(--vn-bg-surface);
}
.vn-ob-halo {
  position: relative;
  background: var(--vn-primary-subtle);
  color: var(--vn-primary-text);
  box-shadow: 0 0 0 6px color-mix(in srgb, var(--vn-primary-subtle) 55%, transparent);
}
`;
